import { getQueryParam } from './helper';
import { EmiPlansRespnse } from './types';
import api from '@/api';
import { API_ENDPOINTS } from '@/constants';

export const fetchEmiPlans = async (pinCode: string): Promise<EmiPlansRespnse> => {
  const paymentId = getQueryParam('id');
  const response = await api(
    `${API_ENDPOINTS.PAYMENT_FETCH}/${paymentId}/emi-plans`,
    {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      pin_code: pinCode,
    },
    {
      method: 'GET',
    },
  );

  if (response.ok) {
    const data = (await response.json()) as EmiPlansRespnse;
    return data;
  }

  throw new Error('Something went wrong');
};
